import './style.scss';
import { useAppSelector } from 'index';
import { FormInterface, sortFormsDescendingByCount } from 'Interfaces/Forms/FormsInterface';
import { getLocalization } from 'global/global';
import * as React from 'react';
import { Badge, Form, ListGroup } from 'react-bootstrap';
import { formsForFiltersSelector, uniqueFormsSelector } from 'reducers/formsReducer';
import { getFormUtils } from 'views/SingleInstance/utils/FormUtilsHolder';
import { isNullOrUndefined } from 'utils/utils';
import { getFormType } from '../../utils';

interface Props {
  selectedForm: string | null;
  validate: boolean;
  setSelectedForm: (id: string) => void;
}

export default function FormsSelection(props: Props) {

  const mainForms = useAppSelector(state => formsForFiltersSelector(state)).sort(sortFormsDescendingByCount);
  const [selected, setSelected] = React.useState('');
  const forms: FormInterface[] = useAppSelector(state => uniqueFormsSelector(state).sort(sortFormsDescendingByCount));
  const [formTableSubforms, setFormTableSubforms] = React.useState<FormInterface[]>([]);

  const onFormSelect = (e) => {
    if (e.target.checked) {
      setSelected(e.target.value);
    } else {
      setSelected('');
    }
  };

  React.useEffect(() => {
    if (selected) {
      const form = mainForms.find(f => f.ref === selected);
      if (form) {
        const fu = getFormUtils(form);
        const tableSubforms = fu.getSubFormQuestionIds().concat(fu.getTableQuestionIds());
        const tableSubFormsIds: string[] = [];
        tableSubforms.forEach(id => {
          const qn = fu.getQuestion(id);
          let ref = '';
          if (qn.table) {
            ref = qn.table?.columns.relation[0].ref;
          } else if (qn.listItems) {
            ref = qn.listItems?.relation[0].ref;
          }
          if (ref && !tableSubFormsIds.includes(ref)) {
            tableSubFormsIds.push(ref);
          }
        });
        if (tableSubFormsIds.length) {
          const tableSubForms = forms.filter(f => tableSubFormsIds.includes(f.ref));
          setFormTableSubforms([form].concat(tableSubForms));
        } else {
          setFormTableSubforms([]);
          props.setSelectedForm(selected);
        }
      } else {
        setFormTableSubforms([]);
      }
    } else {
      setFormTableSubforms([]);
    }
  }, [selected]);

  return (
    <div className="mb-3">
      <div className="d-flex justify-content-between align-items-start">
        <h6 className="ms-2 me-auto">{getLocalization('selectChartForm')}</h6>
        <span className="">{getLocalization('dataPoints')}</span>
      </div>
      <ListGroup className="form-question-selection-list">
        {mainForms.map((form) => (
          <>
            <ListGroup.Item
              key={`chart-guide-${form.ref}`}
              as="li"
              className=""
            >
              <div className="d-flex justify-content-between align-items-start">
                <Form.Check
                  id={`chart-form-down-checkbox-${form.ref}`}
                  type={'checkbox'}
                  label={`${getFormType(form)} ${form.name} `}
                  onChange={onFormSelect}
                  value={form.ref}
                  checked={selected === form.ref}
                  isInvalid={props.validate && !props.selectedForm}
                  className={`ms-2 me-auto ${form.count < 10 ? 'text-muted' : ''}`}
                />
                <Badge bg="primary" pill={true} className="badge-count">
                  {form.count}
                </Badge>
              </div>
              {selected === form.ref && formTableSubforms.length ? (
                <>
                  <ListGroup className="mt-3 form-question-selection-list">
                    {formTableSubforms.map((form) => (
                      <ListGroup.Item
                        key={`chart-guide-${form.ref}`}
                        as="li"
                        className="d-flex justify-content-between align-items-start"
                      >
                        <Form.Check
                          id={`chart-form-down-checkbox-${form.ref}`}
                          type={'checkbox'}
                          label={`${getFormType(form)} ${form.name} `}
                          onChange={(e) => {
                            props.setSelectedForm(e.target.checked ? e.target.value : '');
                          }}
                          value={form.ref}
                          checked={props.selectedForm === form.ref}
                          isInvalid={props.validate && !props.selectedForm}
                          className={`ms-2 me-auto ${form.count < 10 ? 'text-muted' : ''}`}
                        />
                        <span>
                          {isNullOrUndefined(form.count) && (
                            <>
                              {getLocalization('loading')}
                            </>
                          )}
                          <Badge bg="primary" pill={true} className="badge-count">
                            {form.count}
                          </Badge>
                        </span>
                      </ListGroup.Item>
                    ))}
                  </ListGroup>
                </>
              ) : null}
            </ListGroup.Item>
          </>
        ))}
      </ListGroup>
    </div>
  );
}
